import React from 'react';
import { Scissors, Instagram, Facebook, MapPin, Phone } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = ({ t, lang }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-600 rounded-lg flex items-center justify-center">
                <Scissors className="w-5 h-5 text-black" />
              </div>
              <span className="text-xl font-bold text-white">KETUA</span>
            </div>
            <p className="text-gray-400 text-sm">{t.footer.tagline}</p>
            <div className="flex space-x-3">
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{lang === 'id' ? 'Menu Cepat' : 'Quick Links'}</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  {t.nav.home}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  {t.nav.services}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('styles')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  {t.nav.styles}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  {t.nav.gallery}
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">{lang === 'id' ? 'Layanan' : 'Services'}</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Haircut Regular</li>
              <li>Haircut Premium</li>
              <li>Shaving & Facial</li>
              <li>Hair Coloring</li>
              <li>Hair Styling</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.contact.title}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-amber-400 mt-1 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-amber-400 flex-shrink-0" />
                <span>{contactInfo.phone}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">{t.footer.rights}</p>
          <p className="text-gray-600 text-xs mt-2">ketuabarbershop.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
